export default "__VITE_ASSET__D67Hmdl0__"